/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */


import React, { useRef, useState, useEffect } from "react";
import { useLocation } from 'react-router-dom';
import style from "../PrepaidInstance/csd.module.scss";
import "./InstanceForms.scss";
import {
  I2cAccordionStepItem,
  I2cAccordionSteps,
  I2cButton,
  I2cSidebar,
  I2cCard,
  I2cIcon,
  I2cTooltip,
  I2cProgressBar,
  I2cAlert,
} from "@webcomponents/i2cwebcomponents/dist/react";
import { useQuery } from "react-query";
import SecureHeader from "../../Components/SecureHeader/SecureHeader";
import ProgramInfo from "../PrepaidComponents/ProgramInformation/ProgramInformation";
import ProgramFeatures from "../PrepaidComponents/ProgramFeatures";
import AdditionalComment from "../PrepaidComponents/AdditionalComments/AdditionalComment";
import SalesService from "../../Services/SalesService";
import ProjectDetails from "../PrepaidComponents/GeneralInformation/ProjectDetails";
import ContractAndPaymentTerms from "../PrepaidComponents/GeneralInformation/ContractAndPaymentTerms";
import CompanyInformation from "../PrepaidComponents/GeneralInformation/CompanyInformation";
import ContactInformation from "../PrepaidComponents/CompanyProfile/ContactInformation";
import FinancialInstitution from "../PrepaidComponents/CompanyProfile/FinancialInstitution";
import CardNetwork from "../PrepaidComponents/CardNetworkAndBinInfo/CardNetwork";
import FraudManagement from "../PrepaidComponents/OptionalFeatures/FraudManagementService";
import ChargeBackAndDisputeProcessing from "../PrepaidComponents/OptionalFeatures/ChargebackAndDispute";
import ProgramManagementServices from "../PrepaidComponents/OptionalFeatures/ProgramManagementService";
import CardPrinter from "../PrepaidComponents/OptionalFeatures/CardPrinter";
import DigitalWallet from "../PrepaidComponents/OptionalFeatures/DigitalWallet";
import SecureEcommerce from "../PrepaidComponents/OptionalFeatures/SecureEcommerceACS";
import AdminWebsite from "../PrepaidComponents/InterfacesAndComponents/AdminWebsite";
import CustomerServiceWebsite from "../PrepaidComponents/InterfacesAndComponents/CustomerServiceWebsite";
import ACH from "../PrepaidComponents/OtherValueAdded/AutomatedClearingHouse";
import MobileTextMessage from "../PrepaidComponents/OtherValueAdded/MobileTextMessage";
import SSRP from "../PrepaidComponents/OtherValueAdded/NightlyFiles";
import ReviewSummary from "../PrepaidComponents/ReviewSummary/ReviewSummary";
import SignOff from "../PrepaidComponents/SignOff/SignOff";
import AccountUpdateService from "../PrepaidComponents/CardNetworkAndBinInfo/AutomaticAccountUpdater";
import OnlineCardsSales from "../PrepaidComponents/InterfacesAndComponents/OnlineCardsSales";
import CardHolderWebsite from "../PrepaidComponents/InterfacesAndComponents/CardHolderWebsite";
import NativeMobileApplication from "../PrepaidComponents/InterfacesAndComponents/NativeMobileApplication";
import IVRInteractiveVoiceResponse from "../PrepaidComponents/InterfacesAndComponents/IVRInteractiveVoiceResponse";
import ContactCenterServices from "../PrepaidComponents/InterfacesAndComponents/ContactCenterServices";
import BulkCardOrderingPortal from "../PrepaidComponents/InterfacesAndComponents/BulkCardOrderingPortal";
import ViewVirtualCard from "../PrepaidComponents/InterfacesAndComponents/ViewVirtualCard";
import OtherServices from "../PrepaidComponents/OptionalFeatures/OtherServices";
import CooperativeAuthentication from "../PrepaidComponents/CooperativeAuthentication/CooperativeAuthentication";
import VPNSetup from "../PrepaidComponents/ConnectivityAndCommunication/VPNSetup";
import ServertoServerCommunication from "../PrepaidComponents/ConnectivityAndCommunication/ServertoServerCommunication";
import PullAPIs from "../PrepaidComponents/WebAPIs/PullAPIs";
import PushAPIs from "../PrepaidComponents/WebAPIs/PushAPIs";
import I2cStakeHolderReviewSignoff from "../PrepaidComponents/I2cStakeHolderReviewSignOff/I2cStakeHolderReviewSignoff";
import AdditionalNetworkServices from "../PrepaidComponents/CardNetworkAndBinInfo/AdditionalNetworkServices";
import SDK from "../PrepaidComponents/InterfacesAndComponents/SDK";
import AlertMessage from "../../Components/SharedComponent/Alert/Alert";
import ToastContainer from "../../Components/SharedComponent/ToastContainer/ToastContainer";
import UseCaseDocument from "../PrepaidComponents/UseCaseDocument/UseCaseDocument";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import UserManagmentService from "../../Services/UsermanagmentService";
import { UserStateContext } from "../../Context/AuthContext";
import { OverlayLoader } from "../../Components/Loader/Loader";
import ConfirmaionModal from "../../Components/ConfirmationModal/ConfirmationModal";
import ReviewSummarySearch from "../../Components/ReviewSummarySearch/ReviewSummarySearch";


const AccordionStep = () => {
  const location = useLocation();
  const isAddProduct = location.state?.isAddProduct;
  const accordionSteps = useRef(null);
  const [isMobileActive, setIsMobileActive] = useState(false);
  const [isMobileDevice, setIsMobileDevice] = useState(false);
  const nxtBtn = useRef(null);
  const resetBtn = useRef(null);
  const previousBtn = useRef(null);
  const progressStepsContent = useRef(null);
  const [open, setOpen] = useState(true);
  const { id: formId } = useParams();
  const [searchParams, setSearchParams] = useSearchParams();
  const isValidationError = searchParams.get("validation-error") ?? false;
  const isReview = searchParams.get("review-screen") ?? false;
  const appContext = UserStateContext();
  const [showConfirmatonModal, setShowConfirmatonModal] = useState(false);
  const [stakeholderPermissions, setStakeholderPermissions] = useState(null);
  const [isSaving, setIsSaving] = useState(false);

  // Toast references for notifications
  const successAlertRef = useRef(null);
  const errorAlertRef = useRef(null);
  const warningAlertRef = useRef(null);
  const [toastMessage, setToastMessage] = useState({ title: '', description: '' });

  // Guard so the form-lock toast is shown only once per form load.
  const lockToastShownRef = useRef(false);
  useEffect(() => {
    lockToastShownRef.current = false;
  }, [formId]);

  // Function to show toast notifications
  const pushToast = (alert, title, description) => {
    setToastMessage({ title, description });
    setTimeout(() => {
      if (alert.current) {
        alert.current.style.transform = 'translate3d(0, 100%, 150px) scale(1)';
        alert.current.toast();
      }
    }, 100);
  };

  const navigate = useNavigate();
  // useEffect(() => {
  //   if (clientUser) {
  //     setUserRoleCheck(5);
  //   } else {
  //     setUserRoleCheck();
  //   }
  // }, [clientUser]);
  const {
    data: user,
    refetch: refetchUserProfile,
    remove,
  } = useQuery("userProfile", () => UserManagmentService.getUserProfile(), {
    staleTime: 300000,
  });

  useEffect(() => {
    const checkIsMobile = () => {
      setIsMobileDevice(window.innerWidth <= 768);
    };
    checkIsMobile();
    window.addEventListener("resize", checkIsMobile);
    return () => {
      window.removeEventListener("resize", checkIsMobile);
    };
  }, []);
  const toggleMobileClass = () => {
    if (isMobileDevice) {
      setIsMobileActive(!isMobileActive);
    }
  };

  const profileData = user?.data?.data?.user;
  const userRole = String(appContext.userRole || profileData?.role_id || "");
  const roleName = String(
    appContext.roleName || profileData?.role_name || profileData?.roleName || "",
  ).toLowerCase();
  const clientUser = userRole === "5" || roleName === "client";
  const stakeholderUser = userRole === "7" || roleName === "stakeholder";

  useEffect(() => {
    if (clientUser && window.location.pathname.includes("/add")) {
      navigate("/forbidden", {
        replace: true,
      });
    }
  }, [clientUser, navigate]);

  const addUpdateForm = async (payload) => {
    try {
      const response = await SalesService.addUpdateForm(payload);
      // Handle successful response

      return {
        isValid: response.data.status ?? true,
        id: response.data.form ?? formId,
      };
    } catch (error) {
      // Extract error message from backend response
      let errorMessage = "An unexpected error occurred. Please try again.";
      let errorTitle = "Error";
  
      if (error?.response?.data?.message) {
        errorMessage = error.response.data.message;
      } else if (error?.response?.data?.error) {
        errorMessage = error.response.data.error;
      } else if (error?.message) {
        errorMessage = error.message;
      } else if (error?.response?.message) {
        errorMessage = error?.response?.message;
      } else if (error?.response) {
        errorMessage = error?.response?.error;
      }
      // Show error toast
      pushToast(errorAlertRef, errorTitle, errorMessage);
      return {
        isValid: false,
        id: formId,
      };
    }
  };

  const handleButtonClick = () => {
    navigate(".", { replace: true });
  };

  useEffect(() => {
    if (isReview) {
      setTimeout(() => {
        setActiveStep(10, 0);
      }, 1000);
    }
    if (isValidationError || isReview) {
      setTimeout(() => {
        handleButtonClick();
      }, 3000);
    }
  }, [isValidationError, isReview]);
  useEffect(() => {
    if (isAddProduct) {
      setTimeout(() => {
        setActiveStep(4, 0);
      }, 1000);
      setTimeout(() => {
        handleButtonClick();
      }, 1000);
    }
  }, [isAddProduct]);
  const queryKey = ["single-sale", formId];
  const validationQueryKey = ["single-sale-validations", formId];

  const fetchSingleSale = async () => {
    if (formId) {
      const res = await SalesService.fetchSale(formId);
      if (res.data.data === "") {
        navigate("/forbidden");
      }
      const data = JSON.parse(res.data.data[0]?.form_data ?? "{}");
      setAddFormData({ ...data });
      return res.data.data[0];
    }
    return null;
  };

  const fetchSingleSaleValidStates = async () => {
    const res = await SalesService.fetchSalevalidStates(formId);
    return res.data.data[0];
  };

  const fetchFormPermissions = async () => {
    if (formId) {
      const res = await SalesService.getFormPermissions(formId);
      
      return res.data;
    }
    return null;
  };

  // Fetch sessions data using React Query hook
  const {
    data: singleForm,
    isLoading,
    isFetching,
    refetch,
  } = useQuery(queryKey, fetchSingleSale, {
    enabled: !!formId, // Only fetch if formId is present,
    staleTime: Infinity,
  });

  const {
    data: tempSingleFormValidStates,
    isFetching: isValidStatesFetching,
    refetch: refetchFormsValidStates,
  } = useQuery(validationQueryKey, fetchSingleSaleValidStates, {
    enabled: !!formId, // Only fetch if formId is present,
    staleTime: Infinity,
  });

  const {
    data: permissions,
    isLoading: isPermissionsLoading,
    isFetching: isPermissionsFetching,
    refetch: refetchPermissions,
  } = useQuery(
    ["form-permissions", formId],
    fetchFormPermissions,
    {
      enabled: !!formId, // Only fetch if formId is present
      staleTime: Infinity,
      refetchOnMount: "always",
      onSuccess: (data) => {
        if (data) {
          setStakeholderPermissions(data);

          // Form-lock toast: show lock_message when the form is locked and the
          // current user cannot edit it. Skip if the user is the form owner AND
          // is allowed to edit the locked form. Show only once per form load.
          const lock = data.csd_lock;
          const isLocked = lock?.is_locked === 1;
          const canEditLocked = lock?.can_edit_locked_form === true;
          const isOwner = data.is_form_owner === true;
          const ownerCanEdit = isOwner && canEditLocked;
          const stakeHolderStatus = data.stakeholder_status === "approved";

          if (
            isLocked &&
            !canEditLocked &&
            !ownerCanEdit &&
            !lockToastShownRef.current &&
            stakeHolderStatus
          ) {
            lockToastShownRef.current = true;
            pushToast(
              warningAlertRef,
              "Form Locked",
              lock.lock_message,
            );
          }
        }
      },
    }
  );

  // useEffect(() => {
  //   if (permissions) {
  //     setStakeholderPermissions(permissions);
  //   }
  // }, [permissions]);

  useEffect(() => {
    refetchFormsValidStates();
    refetch();
  }, []);

  const singleFormValidStates =
    JSON.parse(tempSingleFormValidStates?.form_validation_states ?? "[]") ?? [];

  const formDataJson = JSON.parse(singleForm?.form_data ?? "{}");
  const signatureDataJson = JSON.parse(singleForm?.signature ?? "{}");
  const StakeholdersignatureDataJson = singleForm?.stakeholder_signoff || [];
  const [activeMainStep, setActiveMainStep] = useState(0);
  const [activeInnerStep, setActiveInnerStep] = useState(0);
  const [reviewSummarySearch, setReviewSummarySearch] = useState("");
  const [activeStepper, setActiveStepper] = useState(0);

  const [formValidStates, setFormValidStates] = useState({
    "0_0": false,
    "0_1": true,
    "0_2": true,
    "0_3": true,
    "0_4": true,
    "1_0": true,
    "1_1": true,
    "2_0": true,
    "2_1": true,
    "2_2": true,
    "2_3": true,
    "2_4": true,
    "2_5": true,
    "3_0": true,
    "3_1": true,
    "3_2": true,
    "3_3": true,
    "3_4": true,
    "3_5": true,
    "3_6": true,
    "3_7": true,
    "3_8": true,
    "3_9": true,
    "4_0": true,
    "4_1": true,
    "4_2": true,
    "4_3": true,
    "4_4": true,
    "4_5": true,
    "5_0": true,
    "5_1": true,
    "6_0": true,
    "6_1": true,
    "7_0": true,
    "8_0": true,
    "9_0": true,
    "10_0": false,
    "11_0": true,
    "12_0": true,
    // "11_1": false,
  });
  const [addFormData, setAddFormData] = useState({
    0: {
      "0_0": {
        pd_client_name: "",
        pd_region: "",
        pd_team_avail: "",
        pd_pid: "",
        pd_ticket_num: "",
        pd_kick_off: "",
        pd_go_live: "",
        pd_sales_rep: "",
        pd_pmo: "",
        pd_solution_architect: "",
        pd_po_resource: "",
        pd_scrum_master: "",
        pd_account_manager: "",
        pd_sales_engineer: "",
      },
      "0_1": {
        cpt_contract_status: "",
        cpt_expiryDate: "",
        cpt_setupCost: "",
        cpt_setupCostCurrency: "USD",
        cpt_minStartDate: "",
        cpt_additional_information: "",
        cpt_payment_terms: "",
        cpt_type_of_i2c_pricing: "",
      },
      "0_2": {
        ci_businessName: "",
        ci_physicalAddress: "",
        ci_mailingAddress: "",
        ci_companyPhone: "",
        ci_companyPhoneCountry: "US",
        ci_companyWebURL: "",
        ci_otherBusinessLoc: "",
        ci_date_business_established: "",
      },
      "0_3": {
        cp_ci_pm_name: "",
        cp_ci_pm_title: "",
        cp_ci_pm_phone_number: "",
        cp_ci_pm_phone_number_country: "",
        cp_ci_pm_cell_number: "",
        cp_ci_pm_cell_number_country: "",
        cp_ci_pm_email: "",
        cp_ci_pm_sign: "yes",
        cp_ci_sc_is_primary: false,
        cp_ci_sc_name: "",
        cp_ci_sc_title: "",
        cp_ci_sc_phone_number: "",
        cp_ci_sc_phone_number_country: "",
        cp_ci_sc_cell_number: "",
        cp_ci_sc_cell_number_country: "",
        cp_ci_sc_email: "",
        cp_ci_brn_is_primary: false,
        cp_ci_brn_name: "",
        cp_ci_brn_title: "",
        cp_ci_brn_phone_number: "",
        cp_ci_brn_phone_number_country: "",
        cp_ci_brn_cell_number: "",
        cp_ci_brn_cell_number_country: "",
        cp_ci_brn_email: "",
        cp_ci_mn_is_primary: false,
        cp_ci_mn_name: "",
        cp_ci_mn_title: "",
        cp_ci_mn_phone_number: "",
        cp_ci_mn_phone_number_country: "",
        cp_ci_mn_cell_number: "",
        cp_ci_mn_cell_number_country: "",
        cp_ci_mn_email: "",
        cp_ci_supp_name: "",
        cp_ci_supp_title: "",
        cp_ci_supp_phone_number: "",
        cp_ci_supp_phone_number_country: "",
        cp_ci_supp_cell_number: "",
        cp_ci_supp_cell_number_country: "",
        cp_ci_supp_email: "",
        cp_ci_supp_is_primary: false,
        cp_ci_ad_is_primary: false,
        cp_ci_ad_name: "",
        cp_ci_ad_title: "",
        cp_ci_ad_phone_number: "",
        cp_ci_ad_phone_number_country: "",
        cp_ci_ad_cell_number: "",
        cp_ci_ad_cell_number_country: "",
        cp_ci_ad_email: "",
        cp_ci_eep_name: "",
        cp_ci_eep_title: "",
        cp_ci_eep_phone_number: "",
        cp_ci_eep_phone_number_country: "",
        cp_ci_eep_cell_number: "",
        cp_ci_eep_cell_number_country: "",
        cp_ci_eep_email: "",
        cp_ci_ees_name: "",
        cp_ci_ees_title: "",
        cp_ci_ees_phone_number: "",
        cp_ci_ees_phone_number_country: "",
        cp_ci_ees_cell_number: "",
        cp_ci_ees_cell_number_country: "",
        cp_ci_ees_email: "",
      },
      "0_4": {
        cp_afi_income_account: "",
        cp_afi_funding_account: "",
        cp_afi_operating_account: "",
        cp_afi_inst_name: "",
        cp_afi_routing_number: "",
        cp_afi_p_contact_name: "",
        cp_afi_p_contact_title: "",
        cp_afi_physical_address: "",
        cp_afi_phone_number: "",
        cp_afi_phone_number_country: "",
        cp_afi_email: "",
        cp_afi_cpm_pci: "",
        cp_afi_cpm_compliant_file: "",
        cp_afi_cpm_pci_other: "",
      },
    },
    1: {
      "1_0": {
        pi_program_name: "",
        pi_standard_time: "est",
        pi_program_debit_or_credit: "prepaid",
        pi_card_program: "",
        pi_program_type_prepaid: 0,
        pi_system_records_debit: [],
        pi_system_records_debit_other: "",
        pi_auth_transac_debit: [],
        pi_auth_transac_debit_other: "",
        pi_program_type_debit: [],
        pi_program_type_debit_other: "",
        pi_selected_commercial_types: [],
        pi_selected_consumer_types: [],
        pi_commercial_type_other: "",
        pi_consumer_type_other: "",
        pi_proposition_value: "",
        pi_segment_value: "",
        pi_card_program_currency: "",
        pi_setup_type: "new-program",
        pi_type_of_migration: "",
        pi_type_of_processor_name: "",
        pi_ecount_1: "",
        pi_ecount_2: "",
        pi_ecount_3: "",
        pi_ecount_4: "",
        pi_evalue_1: "",
        pi_evalue_2: "",
        pi_evalue_3: "",
        pi_evalue_4: "",
        pi_evolume_1: "",
        pi_evolume_2: "",
        pi_evolume_3: "",
        pi_evolume_4: "",
        pi_current_processor_name: "",
        pi_key_component_custodians: [],
        pi_key_component_custodians_other: "",
        pi_data_migration_attributes: [],
        pi_data_migration_attributes_other: "",
        pi_cpm_compliant: "",
        pi_compliant_certificate: "",
        pi_migration_type: "migration-program",
        pi_mig_np_ecount_1: "",
        pi_mig_np_ecount_2: "",
        pi_mig_np_ecount_3: "",
        pi_mig_np_ecount_4: "",
        pi_mig_np_evalue_1: "",
        pi_mig_np_evalue_2: "",
        pi_mig_np_evalue_3: "",
        pi_mig_np_evalue_4: "",
        pi_mig_np_evolume_1: "",
        pi_mig_np_evolume_2: "",
        pi_mig_np_evolume_3: "",
        pi_mig_np_evolume_4: "",
      },
      "1_1": {
        pf_enable_kyc_conduct: "",
        pf_enable_kyc_conduct_no_reason: "",
        pf_kyc_conduct: "",
        pf_kyc_conduct_other: "",
        pf_funding_source_consumer_option: [],
        pf_funding_source_corporate_option: "",
        pf_funding_source_corporate_other_company: "",
        pf_funding_source_corporate_other_contact_name: "",
        pf_funding_source_corporate_other_title: "",
        pf_funding_source_corporate_other_phone: "",
        pf_funding_source_corporate_other_phone_country: "",
        pf_funding_source_corporate_other_email: "",
        pf_funding_source_corporate_other_address: "",
        pf_card_placement: [],
        pf_card_placement_channel: [],
        pf_card_placement_channel_other: "",
        pf_supplimentary_cards_permitted: "",
        pf_supplimentary_cards_age_limit: "",
        pf_card_activation_required: "",
        pf_card_activation_method: "",
        pf_card_activation_channels: [],
        pf_card_activation_channels_other: "",
        pf_card_offline_pin_required: "",
        pf_cardholder_notifications: "",
        pf_cardholder_notifications_channels: "",
        pf_customer_support_channels: [],
        pf_customer_support_provider: "",
        pf_customer_support_provider_other_company: "",
        pf_customer_support_provider_other_contact_name: "",
        pf_customer_support_provider_other_title: "",
        pf_customer_support_provider_other_phone: "",
        pf_customer_support_provider_other_phone_country: "",
        pf_customer_support_provider_other_email: "",
        pf_card_reloading_options: [],
        pf_card_reloading_options_other: "",
        pf_card_activation_parameters: [],
        pf_card_closure_how_will_card_be_closed: "",
        pf_card_closure_how_will_card_account_balance_be_treated_at_card_closure: "",
      },
    },
    2: {
      "2_0": {
        cn_n_networks: [],
        cn_n_networks_other: "",
        cn_atm_networks: [],
        cn_atm_networks_other: "",
        cn_bin_Information: "",
        cn_business_id: "",
        cn_ica: "",
        cn_bin_no: "",
        cn_settlement_currency: "",
        cn_bin_type: "",
        cn_bin_quantity: "",
        cn_bin_quantity_other: "",
        cn_target_date: "",
        cn_insurance_region: "",
        cn_additional_card_information: [],
        cn_additional_card_information_other: "",
        cn_chip_profile: "",
        cn_card_option: "",
        cn_card_number: "",
        cn_card_information: [],
        cn_card_information_other: "",
      },
      "2_1": {
        of_cpfh_company_name: "",
        of_cpfh_name: "",
        of_cpfh_desk: "",
        of_cpfh_email: "",
        of_cpfh_card_manufacturer: "n/a",
        of_cpfh_other_networks: "",
      },
      "2_2": {
        of_dw_mobile_wallets: [],
        of_dw_mobile_wallet_other: "",
        of_dw_card_holders: [],
        of_dw_live_agent: "",
        of_dw_live_agent_other: "",
        of_dw_email_authentication: "",
        of_dw_email_authentication_other: "",
        of_dw_otp_delivery: [],
        of_dw_provisioning_process: "",
        of_dw_i2c_mobile_app_host: "",
        of_dw_service_enable_via: "",
      },
      "2_3": {
        of_acs_enable_acs: "",
        of_acs_acs_provider: "",
        of_acs_provider_other: "",
        of_acs_otp_services: [],
        of_acs_otp_service_other: "",
        of_acs_otp_service_provider: 0,
        of_acs_otp_service_provider_other: "",
      },
      "2_4": {
        cn_automatic_account_updater_service_mastercard_automatic_billing_updater: "",
        cn_automatic_account_updater_service_visa_account_updater: ""
      },
      "2_5": {
        cn_aditional_network_services_would_you_like_to_enable_tap_to_card_on_your_bin: "",
        cn_aditional_network_services_would_you_like_to_enable_tap_to_card_on_your_bin_other: "",
        cn_aditional_network_services_would_you_like_to_enable_click_to_pay_service_on_your_bin: "",
        cn_aditional_network_services_would_you_like_to_enable_click_to_pay_service_on_your_bin_other: "",
      }
    },
    3: {
      "3_0": {
        users: [
          {
            iac_aw_name: "",
            iac_aw_title: "",
            iac_aw_phone: "",
            iac_aw_phone_country: "",
            iac_aw_cell: "",
            iac_aw_cell_country: "",
            iac_aw_email: "",
          },
        ],
      },
      "3_1": {
        ic_csw_web_agent_required: "",
        ic_csw_website_language: [],
        ic_csw_website_language_other: "",
        users: [
          {
            iac_aw_name: "",
            iac_aw_title: "",
            iac_aw_phone: "",
            iac_aw_phone_country: "",
            iac_aw_cell: "",
            iac_aw_cell_country: "",
            iac_aw_email: "",
          },
        ],
      },
      "3_2": {
        online_card_sales_would_you_like_i2c_c_cart: "",
        online_card_sales_i2c_c_card_language: [],
        online_card_sales_i2c_c_card_language_other: "",
      },
      "3_3": {
        cardholder_website_would_you_like_cardholder_website: "",
        cardholder_website_web_language: [],
        cardholder_website_web_language_other: "",
        cardholder_website_url: "",
      },
      "3_4": {
        native_mobile_application_would_you_like_mobile_app: "",
        native_mobile_application_native_platform: [],
        native_mobile_application_mobile_language: [],
        native_mobile_application_mobile_language_other: "",
        native_mobile_application_mobile_app_publishing: [],
      },
      "3_5": {
        ivr_would_you_like_ivr_services: "",
        ivr_language: [],
        ivr_language_other: "",
        ivr_dialing_you_like_to_use_with_ivr: [],
        ivr_dialing_you_like_to_use_with_ivr_other: "",
        ivr_would_you_like_i2c_to_provide_toll_free_number_did: "",
        ivr_would_you_like_to_resporg_your_toll_free_number_to_i2c: "",
      },
      "3_6": {
        contact_center_service_would_you_like_contact_center_service: "",
        contact_center_service_toll_free_number: "",
        contact_center_service_support_language: [],
        contact_center_service_support_language_other: "",
        contact_center_service_expected_hours_of_operation_for_customer_service: "",
        contact_center_service_expected_hours_of_operation_for_customer_service_custom_hrs: "",
        contact_center_service_do_you_want_i2c_to_provide_backup_or_overflow: "",
        contact_center_service_support_hours_required: "",
      },
      "3_7": {
        bulk_card_ordering_portal_would_you_like_c_partner: "",
        bulk_card_ordering_portal_c_partner_language: [],
        bulk_card_ordering_portal_c_partner_language_other: "",
        bulk_card_ordering_portal_url: "",
      },
      "3_8": {
        view_virtual_card_would_you_like_i2c_hosted_view_virtual_card: "",
        view_virtual_card_technology_specification_for_i2c_web_view_integration: [],
        view_virtual_card_technology_specification_for_i2c_web_view_integration_other: "",
        view_virtual_i2c_hosted_web_view_language: [],
        view_virtual_i2c_hosted_web_view_language_other: "",
      },
      "3_9": {
        sdk_application_would_you_like_i2c_hosted_mobile_sdk_app: "",
        sdk_application_technology_specification_for_mobile_sdk_app_integration: [],
        sdk_application_technology_specification_for_mobile_sdk_app_integration_other: "",
        sdk_application_i2c_hosted_mobile_sdk_language: [],
        sdk_application_i2c_hosted_mobile_sdk_language_other: "",
      },
    },
    4: {
      "4_0": {
        of_fm_service_type: "",
        of_fm_company_name: "",
        of_fm_contact_name: "",
        of_fm_job_title: "",
        of_fm_phone_number: "",
        of_fm_country: "",
        of_fm_email: "",
      },
      "4_1": {
        of_cdp_processor: "",
        of_cdp_company_name: "",
        of_cdp_contact_name: "",
        of_cdp_job_title: "",
        of_cdp_phone_number: "",
        of_cdp_country: "",
        of_cdp_email: "",
      },
      "4_2": {
        of_pms_processor: "",
        of_pms_company_name: "",
        of_pms_contact_name: "",
        of_pms_job_title: "",
        of_pms_phone_number: "",
        of_pms_country: "",
        of_pms_email: "",
      },
      "4_3": {
        ov_ach_odfi: "",
        ov_ach_bank: "",
        ov_ach_account: "",
        ov_ach_routing: "",
      },
      "4_4": {
        ov_mtm_service_code: "",
        ov_mtm_service_code_other: "",
        ov_mtm_service_short_code: "",
        ov_mtm_service_use: "",
      },
      "4_5": {
        value_added_service_other_service_additional_setup_monthly_minimum: [],
        value_added_service_other_service_additional_setup_monthly_minimum_other: "",
      }
    },
    5: {
      "5_0": {
        virtual_private_network_secure_vpn_setup_with_i2c: "",
        virtual_private_network_secure_communication_and_connectivity_via_secure_vpn: [],
        virtual_private_network_secure_communication_and_connectivity_via_secure_vpn_other: "",
      },
      "5_1": {
        server_to_server_communication_link_for_file_exchange_what_type_of_communication_would_you_like: "",
        server_to_server_communication_link_for_file_exchange_what_type_of_communication_would_you_like_other: "",
        server_to_server_communication_link_for_file_exchange_would_you_like_to_use_i2c_server_for_file_placement: "",
        server_to_server_communication_link_for_file_exchange_would_you_like_to_use_i2c_server_for_file_placement_other: "",
      },
    },
    6: {
      "6_0": {
        web_services_pull_api_select_version_of_pull_api_you_would_like_to_opt_from_i2c: "",
        web_services_pull_api_do_you_have_an_in_house_development_team: "",
        web_services_pull_api_confirm_if_third_party_vendor_is_pci_compliant: "",
      },
      "6_1": {
        web_services_push_api_would_you_like_i2c_push_notification_to_send_notification_to_your_preferred_channels: "",
        web_services_push_api_please_confirm_channel_to_send_push_notification: "",
        web_services_push_api_please_confirm_channel_to_send_push_notification_other: "",
      },
    },
    7: {
      "7_0": {
        cooperative_authentication_would_you_like_opt_for_cooperative_authorization_with_i2c: "",
        cooperative_authentication_please_confirm_if_client_would_like_to_maintain_the_balances_and_will_be_the_system_of_records: "",
        cooperative_authentication_who_is_providing_core_banking_services: "",
      },
    },
    8: {
      "8_0": {
        ov_nf_ssrp_for_manager: "",
        ov_nf_cut_off_time: "12:00 AM",
        ov_nf_pci_compliant: "",
        ov_nf_comp_cert: "",
      },
    },
    9: {
      "9_0": {
        additional_comment: "",
      },
    },
    10: {
      "10_0": {
        useCaseDocumentTemplateID: "",
        useCaseDocumentTemplateFiles: [],
      },
    },
    11: {
      "11_0": {},
    },
    12: {
      "12_0": {
        architect: {
          name: "",
          title: "",
          status: "",
          date: "",
          comments: "",
          signature: "",
        },
        scrum_master: {
          name: "",
          title: "",
          status: "",
          date: "",
          comments: "",
          signature: "",
        },
        project_manager: {
          name: "",
          title: "",
          status: "",
          date: "",
          comments: "",
          signature: "",
        },
        po: {
          name: "",
          title: "",
          status: "",
          date: "",
          comments: "",
          signature: "",
        },
      },
    },
  });
  const [signatureData, setSignatureData] = useState({
    sign_off_client_name: "",
    sign_off_title: "",
    sign_off_date: "",
    sign_off_signature_type: "",
    sign_off_signature: "",
  });
  function updateKeysToObject(obj, keys) {
    // Create a copy of the original object
    const updatedObject = { ...obj };

    // Loop through the keys array and set the corresponding values in the object to true
    keys.forEach((key) => {
      if (updatedObject.hasOwnProperty(key)) {
        updatedObject[key] = true;
      }
    });

    return updatedObject;
  }

  // Client signature useEffect
  useEffect(() => {
    if (!isFetching && Object.keys(signatureDataJson ?? {})?.length) {
      setSignatureData({ ...signatureDataJson });
    }
  }, [isFetching]);
  useEffect(() => {
    if (!isFetching && StakeholdersignatureDataJson?.length) {
      setAddFormData((prev) => ({
        ...prev,
        stakeholder_signoff: StakeholdersignatureDataJson
      }));
    }
  }, [isFetching]);

  useEffect(() => {
    if (!isValidStatesFetching) {
      const formValidStatesTemp = updateKeysToObject(
        formValidStates,
        singleFormValidStates,
      );
      setFormValidStates(formValidStatesTemp);
    }
  }, [isValidStatesFetching]);

  function handleProgressStep(event) {
    let activeStep;
    if (!event.length) {
      activeStep = event.detail.element.getAttribute("step-id");
    } else activeStep = event;
    const stepContent = progressStepsContent.current.querySelector(
      `#${activeStep}`,
    );
    if (!stepContent) {
      console.warn(`Step content not found for: ${activeStep}`);
      return;
    }
    const allContent = progressStepsContent.current.querySelectorAll("div");
    allContent.forEach((div) => {
      div.classList.remove("active");
    });
    stepContent.classList.add("active");
  }
  const setActiveStep = (main, inner) => {
    if (accordionSteps.current.getActiveTabs()) {
      accordionSteps.current.removeActive();
    }

    const allItems = accordionSteps.current.getItems();
    if ([0, 1, 2, 3, 4, 5, 6, 8, 11].includes(main)) {
      const itemToBeActive = allItems[main].getChildrenItems()[inner];
      const itemToBeActivePath =
        accordionSteps.current.getPathForItem(itemToBeActive);
      accordionSteps.current.markStepInprogress(
        itemToBeActive,
        itemToBeActivePath,
      );
      allItems[main].open = true;
    } else {
      accordionSteps.current.markStepInprogress(allItems[main], [main]);
    }

    if ([0, 1, 2, 3, 4, 5, 6, 8, 11].includes(main))
      handleProgressStep(`step-${main}-${inner}`);
    else handleProgressStep(`step-${main}`);
    setActiveMainStep(main);
    setActiveInnerStep(inner);
  };
  const activeStep = activeMainStep + "_" + activeInnerStep;

  const handleSetFormValidState = (key, value) => {
    setFormValidStates({
      ...formValidStates,
      [key]: value,
    });
  };

  const css = `
    #progress-steps-content {
        @media (max-width: 768px){
          margin-block: 0;
        }
    }
    #progress-steps-content > div {
        display: none;
    }
    #progress-steps-content > div.active {
        display: block;
    }
    i2c-accordion-step-item i2c-accordion-step-item  .step-icon{
      display: none
      }
  `;
  // If stakeholder, show only Review Summary and Stakeholder Sign Off steps
  const stepArray2PV = (stakeholderPermissions?.is_stakeholder === true && stakeholderUser)
    ? [
        {
          id: "step-11PV",
          step_id: "step-11",
          title: "Completion List and Sign off",
          description: "",
          innerSteps: [
            {
              id: "inner-step-11-0",
              title: "Review Summary",
              description: (
                <ReviewSummary
                  addFormData={addFormData}
                  setFormValidStates={handleSetFormValidState}
                  signatureFormData={signatureData}
                  i2cStakeHolderSignOff={singleForm?.stakeholder_signoff}
                  showFormSignature={true}
                  setActiveStep={setActiveStep}
                  isFetching={isFetching}
                  type="debit"
                  searchQuery={reviewSummarySearch}
                />
              ),
              step_id: "step-11-0",
              labelText: "",
              tooltip: "",
            },
          ],
        },
        {
          id: "step-12PV",
          title: "I2C Internal Stakeholder Review & Sign Off",
          step_id: "step-12",
          description: (
            <I2cStakeHolderReviewSignoff
              setAddFormData={setAddFormData}
              addFormData={addFormData}
              formDataJson={{
                ...formDataJson,
                stakeholder_signoff: addFormData.stakeholder_signoff || StakeholdersignatureDataJson
              }}
              setFormValidStates={handleSetFormValidState}
              isFetching={isFetching}
              stakeholderPermissions={stakeholderPermissions}
              formType="debit"
            />
          ),
          labelText: stakeholderPermissions?.stakeholder_type || "Stakeholder",
        },
      ]
    : [
      {
        id: "step-02PV",
        step_id: "step-0",
        title: "Project & Client Information",
        description: "",
        innerSteps: [
          {
            id: "inner-step-0-0",
            title: "Project Information",
            description: (
              <ProjectDetails
                type="debit"
                setAddFormData={setAddFormData}
                addFormData={addFormData}
                setFormValidStates={handleSetFormValidState}
                formDataJson={formDataJson}
                isFetching={isFetching}
              />
            ),
            step_id: "step-0-0",
            labelText: "",
            tooltip: "",
          },
          {
            id: "inner-step-0-1",
            title: "Contract and Payment Terms",
            description: (
              <ContractAndPaymentTerms
                type="debit"
                setAddFormData={setAddFormData}
                addFormData={addFormData}
                setFormValidStates={handleSetFormValidState}
                formDataJson={formDataJson}
                isFetching={isFetching}
              />
            ),
            step_id: "step-0-1",
            labelText: "",
            tooltip: "",
          },
          {
            id: "inner-step-0-2",
            title: "Client Information",
            description: (
              <CompanyInformation
                type="debit"
                setAddFormData={setAddFormData}
                addFormData={addFormData}
                setFormValidStates={handleSetFormValidState}
                formDataJson={formDataJson}
                isFetching={isFetching}
              />
            ),
            step_id: "step-0-2",
            labelText: "",
            tooltip: "",
          },
          {
            id: "inner-step-0-3",
            title: "Key Contacts",
            description: (
              <ContactInformation
                type="debit"
                setAddFormData={setAddFormData}
                addFormData={addFormData}
                setFormValidStates={handleSetFormValidState}
                formDataJson={formDataJson}
                isFetching={isFetching}
              />
            ),
            step_id: "step-0-3",
            labelText: "",
            tooltip: "",
          },
          {
            id: "inner-step-0-4",
            title: "Account & Financial Information",
            description: (
              <FinancialInstitution
                type="debit"
                setAddFormData={setAddFormData}
                addFormData={addFormData}
                setFormValidStates={handleSetFormValidState}
                formDataJson={formDataJson}
                isFetching={isFetching}
              />
            ),
            step_id: "step-0-4",
            labelText: "",
            tooltip: "",
          },
        ],
      },
      {
        id: "step-12PV",
        step_id: "step-1",
        title: "Program Information",
        description: "",
        innerSteps: [
          {
            id: "inner-step-1-0",
            title: "Program Scope",
            description: (
              <ProgramInfo
                type="debit"
                setAddFormData={setAddFormData}
                addFormData={addFormData}
                setFormValidStates={handleSetFormValidState}
                formDataJson={formDataJson}
                isFetching={isFetching}
              />
            ),
            step_id: "step-1-0",
            labelText: "",
            tooltip: "",
          },
          {
            id: "inner-step-1-1",
            title: "Program Features",
            description: (
              <ProgramFeatures
                type="debit"
                setAddFormData={setAddFormData}
                addFormData={addFormData}
                setFormValidStates={handleSetFormValidState}
                formDataJson={formDataJson}
                isFetching={isFetching}
              />
            ),
            step_id: "step-1-1",
            labelText: "",
            tooltip: "",
          },
        ],
      },
      {
        id: "step-22PV",
        step_id: "step-2",
        title: "Card Network & BIN Information",
        description: "",
        innerSteps: [
          {
            id: "inner-step-2-0",
            title: "Card Network & BIN",
            description: (
              <CardNetwork
                setAddFormData={setAddFormData}
                addFormData={addFormData}
                setFormValidStates={handleSetFormValidState}
                formDataJson={formDataJson}
                isFetching={isFetching}
              />
            ),
            step_id: "step-2-0",
            labelText: "",
            tooltip: "",
          },
          {
            id: "inner-step-2-1",
            title: "Card Printer / Fulfillment House",
            description: (
              <CardPrinter
                setAddFormData={setAddFormData}
                addFormData={addFormData}
                setFormValidStates={handleSetFormValidState}
                formDataJson={formDataJson}
                isFetching={isFetching}
              />
            ),
            step_id: "step-2-1",
            labelText: "",
            tooltip: "",
          },
          {
            id: "inner-step-2-2",
            title: "Digital Wallets",
            description: (
              <DigitalWallet
                setAddFormData={setAddFormData}
                addFormData={addFormData}
                setFormValidStates={handleSetFormValidState}
                formDataJson={formDataJson}
                isFetching={isFetching}
              />
            ),
            step_id: "step-2-2",
            labelText:
              "Check the services that are included in your i2c Inc. contract. Contact your Account Manager if you wish to include this feature in your subscription.",
            tooltip: "",
          },
          {
            id: "inner-step-2-3",
            title: "3D Secure Transactions",
            description: (
              <SecureEcommerce
                setAddFormData={setAddFormData}
                addFormData={addFormData}
                setFormValidStates={handleSetFormValidState}
                formDataJson={formDataJson}
                isFetching={isFetching}
              />
            ),
            step_id: "step-2-3",
            labelText:
              "Would you like to enable 3D Secure E-Commerce transactions for your BIN?",
            tooltip:
              "3DS ACS adds an authentication layer to make E-Commerce/card-not-present (CNP) transactions more secure. Authentication methods such as One-time passwords (OTP) can be used for step-up cardholder authentication.",
          },
          {
            id: "inner-step-2-4",
            title: "Automatic Account Updater Service",
            description: (
              <AccountUpdateService
                setAddFormData={setAddFormData}
                addFormData={addFormData}
                setFormValidStates={handleSetFormValidState}
                formDataJson={formDataJson}
                isFetching={isFetching}
              />
            ),
            step_id: "step-2-4",
            labelText: "",
            tooltip: "An account updater service such as Visa Account Updater (VAU) or Mastercard Automatic Billing Updater automatically updates customer card information (like expiration dates and card numbers) with payment networks. It allows issuers to advice merchants of changes to cardholder details. This service minimizes the occurrences of outdated card information for a cardholder that could lead to declined transactions.",
          },
          {
            id: "inner-step-2-5",
            title: "Additional Network Services (TTAC, CTP)",
            description: (
              <AdditionalNetworkServices
                setAddFormData={setAddFormData}
                addFormData={addFormData}
                setFormValidStates={handleSetFormValidState}
                formDataJson={formDataJson}
                isFetching={isFetching}
              />
            ),
            step_id: "step-2-5",
            labelText:
              "Please selected the additional network services that needs to be configured on the BIN ",
            tooltip:
              "",
          },
        ],
      },
      {
        id: "step-32PV",
        title: "Interfaces & Components",
        description: "",
        step_id: "step-3",
        innerSteps: [
          {
            id: "ic-0",
            title: "Admin Website (C-Admin)",
            description: (
              <AdminWebsite
                setAddFormData={setAddFormData}
                addFormData={addFormData}
                setFormValidStates={handleSetFormValidState}
                formDataJson={formDataJson}
                isFetching={isFetching}
              />
            ),
            step_id: "step-3-0",
            labelText:
              "C-Admin allows you to manage self-service platform functionality. Program Managers can access the website to define card programs, services, and rules. ",
            tooltip:
              "Please check if the contract with i2c Inc. covers the below optional interfaces and components; separate setup and monthly fees may apply.",
          },
          {
            id: "ic-1",
            title: "Customer Service Website (C-Agent)",
            description: (
              <CustomerServiceWebsite
                setAddFormData={setAddFormData}
                addFormData={addFormData}
                setFormValidStates={handleSetFormValidState}
                formDataJson={formDataJson}
                isFetching={isFetching}
              />
            ),
            step_id: "step-3-1",
            labelText:
              "This site facilitates your bank and support staff to log, track and manage customer inquiries, search for cardholders, change cardholder profiles, view transaction details, reverse / applied fee etc. It also allows them to view card program details and parameters.",
            tooltip:
              "Please check if the contract with i2c Inc. covers the below optional interfaces and components; separate setup and monthly fees may apply.",
          },
          {
            id: "inner-step-3-2",
            title: "Online Card Sales / Self Service Enrollment (C-Cart)",
            description: (
              <OnlineCardsSales
                setAddFormData={setAddFormData}
                addFormData={addFormData}
                setFormValidStates={handleSetFormValidState}
                formDataJson={formDataJson}
                isFetching={isFetching}
              />
            ),
            step_id: "step-3-2",
            labelText: "The C-Cart Web site enables consumers to apply for/order cards online. This site is customizable, your Implementation Manager will forward specs and request for branding deliverables on a separate document.",
            tooltip: "",
          },
          {
            id: "inner-step-3-3",
            title: "Cardholder Website (C-Holder Web)",
            description: (
              <CardHolderWebsite
                setAddFormData={setAddFormData}
                addFormData={addFormData}
                setFormValidStates={handleSetFormValidState}
                formDataJson={formDataJson}
                isFetching={isFetching}
              />
            ),
            step_id: "step-3-3",
            labelText: "The Cardholder Website allows cardholders to manage their card accounts, view card account activity, make bill payments, and perform other similar activities.This site is customizable, your Implementation Manager will forward specs and request for branding deliverables on a separate document.",
            tooltip: "",
          },
          {
            id: "inner-step-3-4",
            title: "Native Mobile Application (C-Holder Mobile)",
            description: (
              <NativeMobileApplication
                setAddFormData={setAddFormData}
                addFormData={addFormData}
                setFormValidStates={handleSetFormValidState}
                formDataJson={formDataJson}
                isFetching={isFetching}
              />
            ),
            step_id: "step-3-4",
            labelText: "The Mobile Application allows cardholders to manage their card accounts, view transaction history, and perform other similar activities.It is an iOS or Android based native application and can be branded. Your Implementation Manager will forward the Mobile Application CSD and request for branding deliverables separatel",
            tooltip: "",
          },
          {
            id: "inner-step-3-5",
            title: "IVR - Interactive Voice Response (C-Touch)",
            description: (
              <IVRInteractiveVoiceResponse
                setAddFormData={setAddFormData}
                addFormData={addFormData}
                setFormValidStates={handleSetFormValidState}
                formDataJson={formDataJson}
                isFetching={isFetching}
              />
            ),
            step_id: "step-3-5",
            labelText: "i2c’s automated telephony system interacts with callers, allows for identification through dial pad, and collects information that can be relayed to the customer support representative.",
            tooltip: "",
          },
          {
            id: "inner-step-3-6",
            title: "Contact Center Services (Live Operator)",
            description: (
              <ContactCenterServices
                setAddFormData={setAddFormData}
                addFormData={addFormData}
                setFormValidStates={handleSetFormValidState}
                formDataJson={formDataJson}
                isFetching={isFetching}
              />
            ),
            step_id: "step-3-6",
            labelText: "i2c offers a 24x7x365 operator service where consumers can contact a customer services representative to inquire about your products, handle complaints and process orders. Your Implementation Manager will forward specs and request for setup on a separate Departmental Control Functional Checklist (DCFC) document.",
            tooltip: "",
          },
          {
            id: "inner-step-3-7",
            title: "Bulk Card Ordering Portal (C-Partner)",
            description: (
              <BulkCardOrderingPortal
                setAddFormData={setAddFormData}
                addFormData={addFormData}
                setFormValidStates={handleSetFormValidState}
                formDataJson={formDataJson}
                isFetching={isFetching}
              />
            ),
            step_id: "step-3-7",
            labelText: "C-Partner, i2c’s web-based portal for business partners, can be used to issue and manage corporate and employee credit cards. Users can view account activity, redeem credit card rewards, download and email/mail account statements, and make credit card payments.",
            tooltip: "",
          },
          {
            id: "inner-step-3-8",
            title: "Web View / Virtual Card",
            description: (
              <ViewVirtualCard
                setAddFormData={setAddFormData}
                addFormData={addFormData}
                setFormValidStates={handleSetFormValidState}
                formDataJson={formDataJson}
                isFetching={isFetching}
              />
            ),
            step_id: "step-3-8",
            labelText: "i2c’s WebView Application can be used by clients to enable their cardholders to view virtual card/ account details or perform certain card management functions. Clients who are not compliant with PCI data  standards or cannot use i2c API can also opt for the WebView Application. The WebView Application can be enabled for both Web and Native Mobile Apps (iOS and Android).",
            tooltip: "",
          },
          {
            id: "inner-step-3-9",
            title: "i2c Mobile SDK Application",
            description: (
              <SDK
                setAddFormData={setAddFormData}
                addFormData={addFormData}
                setFormValidStates={handleSetFormValidState}
                formDataJson={formDataJson}
                isFetching={isFetching}
              />
            ),
            step_id: "step-3-9",
            labelText: "i2c mobile SDK application provides numerous features to i2c clients who choose to host their own native mobile app (IOS ad Android).",
            tooltip: "",
          },
        ],
      },
      {
        id: "step-42PV",
        title: "Value Added Services",
        description: "",
        step_id: "step-4",
        innerSteps: [
          {
            id: "of-0",
            title: "Fraud Management Service",
            description: (
              <FraudManagement
                setAddFormData={setAddFormData}
                addFormData={addFormData}
                setFormValidStates={handleSetFormValidState}
                formDataJson={formDataJson}
                isFetching={isFetching}
              />
            ),
            step_id: "step-4-0",
            labelText: "Please pick an option that you want to subscribe to",
            tooltip: "",
          },
          {
            id: "of-1",
            title: "Chargeback & Dispute Processing",
            description: (
              <ChargeBackAndDisputeProcessing
                setAddFormData={setAddFormData}
                addFormData={addFormData}
                setFormValidStates={handleSetFormValidState}
                formDataJson={formDataJson}
                isFetching={isFetching}
              />
            ),
            step_id: "step-4-1",
            labelText: "Please pick an option that you want to subscribe to:",
            tooltip: "",
          },
          {
            id: "of-2",
            title: "Program Management Services",
            description: (
              <ProgramManagementServices
                setAddFormData={setAddFormData}
                addFormData={addFormData}
                setFormValidStates={handleSetFormValidState}
                formDataJson={formDataJson}
                isFetching={isFetching}
              />
            ),
            step_id: "step-4-2",
            labelText:
              "This service includes consulting and management of card programs, including operational support and management of key program components to ensure that they are optimized for growth and profitability.",
            tooltip: "",
          },
          {
            id: "of-3",
            title: "Automated Clearing House – ACH",
            description: (
              <ACH
                setAddFormData={setAddFormData}
                addFormData={addFormData}
                setFormValidStates={handleSetFormValidState}
                formDataJson={formDataJson}
                isFetching={isFetching}
              />
            ),
            step_id: "step-4-3",
            labelText: "Please confirm the ODFI institute for ACH services.",
            tooltip: "",
          },
          {
            id: "of-4",
            title: "Mobile Text Messaging Service (mRay)",
            description: (
              <MobileTextMessage
                setAddFormData={setAddFormData}
                addFormData={addFormData}
                setFormValidStates={handleSetFormValidState}
                formDataJson={formDataJson}
                isFetching={isFetching}
              />
            ),
            step_id: "step-4-4",
            labelText: "To send text based messages (SMS), a client need to acquire a dedicated short code.",
            tooltip: "",
          },
          {
            id: "of-5",
            title: "Other Services",
            description: (
              <OtherServices
                setAddFormData={setAddFormData}
                addFormData={addFormData}
                setFormValidStates={handleSetFormValidState}
                formDataJson={formDataJson}
                isFetching={isFetching}
              />
            ),
            step_id: "step-4-5",
            labelText: "Additional setup and monthly minimum may apply.",
            tooltip: "",
          },
        ],
      },
      {
        id: "step-52PV",
        title: "Connectivity & File Exchange",
        description: "",
        step_id: "step-5",
        innerSteps: [
          {
            id: "ic-0",
            title: "Virtual Private Network (VPN)",
            description: (
              <VPNSetup
                setAddFormData={setAddFormData}
                addFormData={addFormData}
                setFormValidStates={handleSetFormValidState}
                formDataJson={formDataJson}
                isFetching={isFetching}
              />
            ),
            step_id: "step-5-0",
            labelText: "",
            tooltip: "VPN is a prerequisite for web services API setup.",
          },
          {
            id: "ic-1",
            title: "Server to Server Communication Link for File Exchange",
            description: (
              <ServertoServerCommunication
                setAddFormData={setAddFormData}
                addFormData={addFormData}
                setFormValidStates={handleSetFormValidState}
                formDataJson={formDataJson}
                isFetching={isFetching}
              />
            ),
            step_id: "step-5-1",
            labelText: "",
            tooltip: "",
          },
        ],
      },
      {
        id: "step-62PV",
        title: "Web Services API",
        description: "",
        step_id: "step-6",
        innerSteps: [
          {
            id: "ic-0",
            title: "Pull APIs",
            description: (
              <PullAPIs
                setAddFormData={setAddFormData}
                addFormData={addFormData}
                setFormValidStates={handleSetFormValidState}
                formDataJson={formDataJson}
                isFetching={isFetching}
              />
            ),
            step_id: "step-6-0",
            labelText: "i2c Web Services API enable card issuers and program owners to run payment programs smoothly and securely. With the i2c API, program owners can leverage i2c’s platform to fully manage a card product’s life cycle.",
            tooltip: "i2c API’s cover all aspects of payment program including enrollment, profile management, authorization, history, bill payments, loads, digital wallets, statement transfers, fee, bank accounts, tokenization and loyalty & rewards. Please note to connect with i2c Web Services Pull API, communication over a secure tunnel VPN is mandatory.",
          },
          {
            id: "ic-1",
            title: "Push APIs",
            description: (
              <PushAPIs
                setAddFormData={setAddFormData}
                addFormData={addFormData}
                setFormValidStates={handleSetFormValidState}
                formDataJson={formDataJson}
                isFetching={isFetching}
              />
            ),
            step_id: "step-6-1",
            labelText: "",
            tooltip: "",
          },
        ],
      },
      {
        id: "step-72PV",
        title: "Cooperative Authentication",
        description: (
          <CooperativeAuthentication
            type="credit"
            setAddFormData={setAddFormData}
            addFormData={addFormData}
            setFormValidStates={handleSetFormValidState}
            formDataJson={formDataJson}
            isFetching={isFetching}
          />
        ),
        step_id: "step-7",
      },
      {
        id: "step-82PV",
        title: "Settlement & Reconciliation",
        description: "",
        step_id: "step-8",
        innerSteps: [
          {
            id: "ic-0",
            title: "Nightly Files (SSRP)",
            description: (
              <SSRP
                setAddFormData={setAddFormData}
                addFormData={addFormData}
                setFormValidStates={handleSetFormValidState}
                formDataJson={formDataJson}
                isFetching={isFetching}
              />
            ),
            step_id: "step-8-0",
            labelText: "",
            tooltip: "",
          },

      ],
    },
    {
      id: "step-92PV",
      title: "Additional Comments ",
      step_id: "step-9",
      description: (
        <AdditionalComment
          setAddFormData={setAddFormData}
          addFormData={addFormData}
          formDataJson={formDataJson}
          setFormValidStates={handleSetFormValidState}
          isFetching={isFetching}
        />
      ),
    },
    {
      id: "step-10PV",
      title: "Use Case Document ",
      step_id: "step-10",
      description: (
        <UseCaseDocument
          setAddFormData={setAddFormData}
          addFormData={addFormData}
          formDataJson={formDataJson}
          setFormValidStates={handleSetFormValidState}
          isFetching={isFetching}
        />
      ),
    },
    {
      id: "step-11PV",
      step_id: "step-11",
      title: "Completion List and Sign off",
      description: "",
      innerSteps: [
        {
          id: "inner-step-11-0",
          title: "Review Summary",
          description: (
            <ReviewSummary
              addFormData={addFormData}
              setFormValidStates={handleSetFormValidState}
              signatureFormData={signatureData}
              i2cStakeHolderSignOff={singleForm?.stakeholder_signoff}
              showFormSignature={true}
              setActiveStep={setActiveStep}
              isFetching={isFetching}
              type="debit"
              searchQuery={reviewSummarySearch}
            />
          ),
          step_id: "step-11-0",
          labelText: "",
          tooltip: "",
        },
      ],
    },

    ];


  // Conditionally add I2C Stakeholder Review & Sign Off step
  // Show if user is stakeholder and form status is 4
  if (
    stakeholderPermissions?.is_stakeholder === true && !(stakeholderUser)
  ) {
    stepArray2PV.push({
      id: "step-12PV",
      title: "I2C Internal Stakeholder Review & Sign Off",
      step_id: "step-12",
      description: (
        <I2cStakeHolderReviewSignoff
          setAddFormData={setAddFormData}
          addFormData={addFormData}
          formDataJson={{
            ...formDataJson,
            stakeholder_signoff: addFormData.stakeholder_signoff || StakeholdersignatureDataJson
          }}
          setFormValidStates={handleSetFormValidState}
          isFetching={isFetching}
          stakeholderPermissions={stakeholderPermissions}
          formType="debit"
        />
      ),
      labelText: stakeholderPermissions?.stakeholder_type || "Stakeholder",
    });
  }

  if (clientUser) {
    const step11PV = stepArray2PV.find((step) => step.id === "step-11PV");
    if (
      step11PV &&
      !step11PV.innerSteps.find((step) => step.id === "inner-step-11-1")
    ) {
      // Ensure the step does not already exist before appending
      step11PV.innerSteps.push({
        id: "inner-step-11-1",
        title: "Sign Off",
        description: (
          <SignOff
            setAddFormData={setSignatureData}
            addFormData={signatureData}
            setFormValidStates={handleSetFormValidState}
            formDataJson={signatureDataJson}
            isFetching={isFetching}
            type="debit"
          />
        ),
        step_id: "step-11-1",
        labelText: "",
        tooltip: "",
      });
    }
  }

  useEffect(() => {
    if (clientUser && singleForm?.form_status_id !== 4) {
      setFormValidStates((prevState) => ({
        ...prevState,
        "11_1": false,
      }));

      const updatedAddFormData = { ...addFormData };
      setAddFormData(updatedAddFormData);
    }
  }, [clientUser, singleForm?.form_status_id]);

  const handleNext = async () => {
    if (clientUser && activeMainStep + "_" + activeInnerStep === "11_0") {
      setActiveStep(11, 1);
      navigate(`/debit/edit/${formId}`);
    } else if (
      !clientUser &&
      activeMainStep + "_" + activeInnerStep === "11_0"
    ) {
      if (isFormSubmittable) {
        navigate(`/debit/success/${formId}`);
      }
    } else {
      setIsSaving(true);
      const formDataPayload = {
        form_type: 1,
        form_data: {
          ...addFormData,
          11: {
            ...addFormData[11],
            "11_1": {},
          },
        },
        outer_index: stakeholderPermissions?.is_stakeholder === true && stakeholderUser ? 12 : activeMainStep,
        form_status_id: formId ? singleForm?.form_status_id ?? 1 : 1,
        inner_index: stakeholderPermissions?.is_stakeholder === true && stakeholderUser ? "12_0" : activeMainStep + "_" + activeInnerStep,
      };
      if (formId) {
        formDataPayload["id"] = formId;
        formDataPayload.form_singature = signatureData;
      }
      const res = await addUpdateForm(formDataPayload);
      if (res.isValid) {
        // Show success toast
        pushToast(
          successAlertRef,
          'Successfully Saved',
          'Your changes have been saved successfully.'
        );

        if (clientUser && activeMainStep + "_" + activeInnerStep === "11_1") {
          navigate(`/debit/success/${res.id}`);
        } else if (stakeholderPermissions?.is_stakeholder === true && stakeholderUser && activeMainStep + "_" + activeInnerStep === "1_0") {
          navigate(`/debit/success/${res.id}`);
        } else {
          refetchFormsValidStates();
          const activeStep = stepArray2PV[activeMainStep];
          const innerSteps = activeStep.innerSteps;
          if (innerSteps && activeInnerStep < innerSteps.length - 1) {
            setActiveStep(activeMainStep, activeInnerStep + 1);
          } else if (activeMainStep < stepArray2PV.length - 1) {
            setActiveStep(activeMainStep + 1, 0);
          }
          navigate(`/debit/edit/${res.id}`);
        }
      } else {
        searchParams.set("validation-error", true);
        setSearchParams(searchParams);
      }
      setIsSaving(false);
    }
  };

  function handlePrevious() {
    accordionSteps.current.setPreviousStep();
  }

  function handleResetPopup() {
    setShowConfirmatonModal(true);
  }

  function checkParentStepValidation(array, prefix, count) {
    // Filter the array to get only the strings that start with the specified prefix
    const filteredStrings = array.filter((str) => str.startsWith(prefix));

    // Check if the count of filtered strings matches the expected count
    return filteredStrings.length === count;
  }

  const formValidatonConditions = [
    { prefix: "0_", count: 5 },
    { prefix: "1_", count: 2 },
    { prefix: "2_", count: 6 },
    { prefix: "3_", count: 10 },
    { prefix: "4_", count: 6 },
    { prefix: "5_", count: 2 },
    { prefix: "6_", count: 2 },
    { prefix: "7_", count: 1 },
    { prefix: "8_", count: 1 },
    { prefix: "9_", count: 1 },
    { prefix: "10_", count: 1 },
    { prefix: "11_", count: 1 },
    { prefix: "12_", count: 1 },
  ];

  // Progress tracks only content steps (0-10); review & stakeholder sign-off steps don't count.
  const contentConditions = formValidatonConditions.filter(
    (c) => c.prefix !== "11_" && c.prefix !== "12_"
  );

  const countValidSteps = (formValidatonConditions, keysArray) => {
    let totalCount = 0;

    formValidatonConditions.forEach((condition) => {
      const matchingKeys = keysArray?.filter((key) =>
        key.startsWith(condition.prefix),
      );
      if (matchingKeys?.length === condition.count) totalCount += 1;
    });

    return totalCount;
  };

  const isFormSubmittable =
    tempSingleFormValidStates?.form_status_id !== 1 &&
    Object.values(formValidStates).every((value) => value === true);

  // useEffect(() => {
  //   if (progressStepper2PV) {
  //     progressStepper2PV.steps = steps;
  //   }
  // }, [progressStepper2PV, steps]);
  const sidebarComponent = (
    <I2cSidebar
      className={`${isMobileActive ? "activeMobileClass " : ""}i2c-prepaid-instance-sidebar`}
      // className="i2c-prepaid-instance-sidebar"
      // auto-hide
      hasBottomNav
      open={open}
      noEscapeClose
      id="I2cSidebar3"
      position="absolute"
      contained
    >
      <div className="bg_contain" slot="filter">
        <h3>Prepaid Instance</h3>
        <div className="progress-holder" onClick={toggleMobileClass}>
          <I2cProgressBar
            value={
              stakeholderPermissions?.is_stakeholder === true && stakeholderUser
                ? (countValidSteps(
                    formValidatonConditions.filter(cond => cond.prefix === "11_" || cond.prefix === "12_"),
                    singleFormValidStates
                  ) / 2) * 100
                : (countValidSteps(contentConditions, singleFormValidStates) / contentConditions.length) * 100
            }
            variant="success"
            style={{ "--height": "var(--i2c-spacing-2)" }}
          ></I2cProgressBar>
          <span className="custom-label secondary-color">
            {stakeholderPermissions?.is_stakeholder === true && stakeholderUser
              ? countValidSteps(
                  formValidatonConditions.filter(cond => cond.prefix === "11_" || cond.prefix === "12_"),
                  singleFormValidStates
                )
              : countValidSteps(contentConditions, singleFormValidStates)
            }
            /{stakeholderPermissions?.is_stakeholder === true && stakeholderUser ? '2' : contentConditions.length}
          </span>
          {isMobileDevice && (
            <I2cIcon
              className="custom-label-icon"
              name={
                isMobileActive
                  ? "cs-linear-chevron-up"
                  : "cs-linear-chevron-down"
              }
            ></I2cIcon>
          )}
        </div>
      </div>
      <div slot="content">
        <div className="card-basic">
          <I2cCard className="card-basic">
            <I2cAccordionSteps
              key={String(stakeholderPermissions?.is_stakeholder)}
              className={style.accordReset}
              ref={accordionSteps}
              onI2cUpdatedProgress={(event) => {
                handleButtonClick();
                const path = event?.detail?.path ?? [];
                setActiveMainStep(path[0]);
                setActiveInnerStep(path[1] ?? 0);
                handleProgressStep(event);
                setTimeout(() => {
                  const elements = document.getElementsByClassName("active");
                  if (elements?.length)
                    elements[0]?.scrollIntoView({ behavior: "smooth" });
                }, 300);
              }}
              type="parentLine"
              variant="borderless"
              size="md"
            >
              {stepArray2PV.map((parentStep, index) => {
                const parentStepNo = parentStep.step_id.split("-")[1];
                return (
                  <I2cAccordionStepItem
                    key={parentStep.step_id + index}
                    title={parentStep.title}
                    description=""
                    step-id={parentStep.step_id}
                    status={
                      checkParentStepValidation(
                        singleFormValidStates,
                        parentStepNo + "_",
                        formValidatonConditions.find(
                          (cond) => cond.prefix === parentStepNo + "_",
                        )?.count,
                      ) && activeMainStep !== Number(parentStepNo)
                        ? "complete"
                        : activeMainStep === Number(parentStepNo)
                          ? "inprogress"
                          : "incomplete"
                    }
                    auto-collapse
                  >
                    {parentStep.innerSteps &&
                      parentStep.innerSteps.map((childStep, index) => {
                        // const arr = childStep.step_id.replace(
                        //   /step-(\d+)-(\d+)/,
                        //   "$1_$2",
                        // );
                        return (
                          <I2cAccordionStepItem
                            className={style.innerStep_dot}
                            key={childStep.step_id + index}
                            title={childStep.title}
                            status={
                            singleFormValidStates.includes(`${parentStepNo}_${index}`) &&
                            !(activeMainStep === Number(parentStepNo) && activeInnerStep === index)
                              ? "complete"
                              : activeMainStep === Number(parentStepNo) && activeInnerStep === index
                                ? "inprogress"
                                : "incomplete"
                          }
                            // status={
                            //   arr ===
                            //   activeMainStep + "_" + activeInnerStep
                            //     ? "inprogress"
                            //     : singleFormValidStates.includes(
                            //           activeMainStep +
                            //             "_" +
                            //             activeInnerStep,
                            //         ) &&
                            //         arr !==
                            //           activeMainStep +
                            //             "_" +
                            //             activeInnerStep
                            //       ? "complete"
                            //       : "incomplete"
                            // }
                            description=""
                            step-id={childStep.step_id}
                          />
                        );
                      })}
                  </I2cAccordionStepItem>
                );
              })}
            </I2cAccordionSteps>
          </I2cCard>
        </div>
      </div>
    </I2cSidebar>
  );
  return (
    <>
      <div className="InstanceForms-wrapper">
        <div className="header-outer">
          <SecureHeader />
        </div>
        <div id={"main"} className="demoContent">
          {isMobileDevice ? (
            <div className="sidebar_tablet_responsive">{sidebarComponent}</div>
          ) : (
            sidebarComponent
          )}

          <div part={"content"}>
            <div className="contentContainer instance-container">
              <div id="progress-steps-content" ref={progressStepsContent}>
                {stepArray2PV.map((parent, parentIndex) => (
                  <React.Fragment key={parent.step_id}>
                    <div
                      id={parent.step_id}
                      className={activeStepper === parentIndex ? "active" : ""}
                    >
                      <div
                        className={
                          style.main_step_title + " title-subtitle-space"
                        }
                      >
                        {parent.title}
                      </div>
                      {/* <I2cDivider style={{ "--borderWidth": "1px" }} /> */}
                      {/* className="prepaidform_desc" */}
                      <div>
                        {parent.description}{" "}
                      </div>
                    </div>
                    {parent.innerSteps &&
                      parent.innerSteps.map((child, childIndex) => (
                        <div
                          key={child.step_id}
                          id={child.step_id}
                          className={
                            activeStepper === parentIndex && childIndex === 0
                              ? "active"
                              : ""
                          }
                        >
                          <div
                            className={
                              style.main_step_title + " title-subtitle-space"
                            }
                          >
                            <div className="review-summary-step-header">
                              <span>{parent.title}</span>
                              {(Number(activeMainStep) === 11 || (stakeholderPermissions?.is_stakeholder === true && stakeholderUser)) &&
                                Number(activeInnerStep) === 0 && (
                                  <ReviewSummarySearch
                                    value={reviewSummarySearch}
                                    onSearchChange={setReviewSummarySearch}
                                  />
                                )}
                            </div>

                          </div>
                          {child.tooltip !== "" ? (
                            <>
                              {child.labelText === "" ? (
                                <div className="inner-step-title mb-24">
                                  <span
                                    slot="label"
                                    className="organize-tooltip"
                                  >
                                    {child.title}
                                    <I2cTooltip
                                      content={child.tooltip}
                                      placement="right-start"
                                    >
                                      <I2cIcon
                                        label="placement"
                                        name="cs-linear-info"
                                        color="#6B7080"
                                      ></I2cIcon>
                                    </I2cTooltip>
                                  </span>
                                </div>
                              ) : (
                                <>
                                  {child.title ===
                                    "3D Secure E-Commerce ACS Service" ? (
                                    <div className="mb-16">
                                      <div className="inner-step-title">
                                        <span
                                          slot="label"
                                          className="organize-tooltip"
                                        >
                                          <span className="sterik">
                                            3DS ACS
                                            <sup>•</sup>
                                          </span>
                                          <I2cTooltip
                                            content={child.tooltip}
                                            placement="right-start"
                                          >
                                            <I2cIcon
                                              label="placement"
                                              name="cs-linear-info"
                                              color="#6B7080"
                                            ></I2cIcon>
                                          </I2cTooltip>
                                        </span>
                                      </div>
                                      <div className="custom-label-light-parent">
                                        <div>{child.labelText}</div>
                                      </div>
                                    </div>
                                  ) : (
                                    <div className="mb-24">
                                      <div className="inner-step-title">
                                        <span
                                          slot="label"
                                          className="organize-tooltip"
                                        >
                                          {child.title}
                                          <I2cTooltip
                                            content={child.tooltip}
                                            placement="right-start"
                                          >
                                            <I2cIcon
                                              label="placement"
                                              name="cs-linear-info"
                                              color="#6B7080"
                                            ></I2cIcon>
                                          </I2cTooltip>
                                        </span>
                                      </div>
                                      <div className="custom-label-light-parent">
                                        <div>{child.labelText}</div>
                                      </div>
                                    </div>
                                  )}
                                </>
                              )}
                            </>
                          ) : (
                            <>
                              {child.labelText === "" ? (
                                <div className="inner-step-title mb-24">
                                  {child.title}
                                </div>
                              ) : (
                                <div className="mb-24">
                                  <div className="inner-step-title">
                                    {child.title}
                                  </div>
                                  <div className="custom-label-light-parent">
                                    <div>{child.labelText}</div>
                                  </div>
                                </div>
                              )}
                            </>
                          )}
                          <div> {child.description} </div>
                        </div>
                      ))}
                  </React.Fragment>
                ))}
              </div>
            </div>
          </div>
          <div className={style.cta_container}>
            <div className={style.CtaContainer}>
              {activeStep === "0_0" ? (
                <span></span>
              ) : (
                <I2cButton
                  variant="secondary gray"
                  ref={previousBtn}
                  onClick={handlePrevious}
                >
                  {isMobileDevice ? (
                    <I2cIcon
                      name="cs-linear-chevron-left"
                      label="Previous"
                    ></I2cIcon>
                  ) : (
                    "Previous"
                  )}
                </I2cButton>
              )}

              {/* disabled={!formValidStates[activeStep]} */}
              <div layout="column" className={style.cta_btn_flex_inner}>
                <I2cButton
                  variant="secondary gray"
                  ref={resetBtn}
                  onClick={handleResetPopup}
                >
                  Cancel
                </I2cButton>
                <I2cButton
                  disabled={
                    isSaving || (
                      !clientUser &&
                        activeMainStep + "_" + activeInnerStep === "11_0" &&
                        !isFormSubmittable
                        ? true
                        : activeStep === "11_0"
                          ? false
                          : !formValidStates[activeStep]
                    )
                  }
                  ref={nxtBtn}
                  onClick={handleNext}
                >
                  {
                    (stakeholderPermissions?.is_stakeholder === true && stakeholderUser &&
                      activeMainStep + "_" + activeInnerStep === "1_0") ||
                      (stakeholderPermissions?.is_stakeholder === true && !stakeholderUser &&
                      activeMainStep + "_" + activeInnerStep === "12_0") ||
                      (clientUser &&
                        activeMainStep + "_" + activeInnerStep === "11_1") ||
                      (!clientUser && stakeholderPermissions?.is_stakeholder === false &&
                        activeMainStep + "_" + activeInnerStep === "11_0") ||
                      (stakeholderPermissions?.is_stakeholder === true && stakeholderUser &&
                        activeMainStep + "_" + activeInnerStep === "1_0")
                      ? "Submit"
                      : "Save & Continue"}
                </I2cButton>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ConfirmaionModal
        open={showConfirmatonModal}
        parentClass="height-fix"
        setOpen={() => setShowConfirmatonModal(false)}
        title={"Unsaved Changes?"}
        headerArt={"cs-linear-alert-circle"}
        message={"Are you sure you want to discard these changes?"}
        variant="warning"
        layout={"layoutCenter"}
        cancelButtonText={"Skip"}
        confirmButtonText={"Yes"}
        confirmBtnVariant={"primary"}
        handleConfirmation={() => navigate(-1)}
      />
      {(isLoading || isFetching || isSaving || isPermissionsLoading) && <OverlayLoader />}

      {/* Toast Notifications */}
      <div>
        <ToastContainer
          successAlertRef={successAlertRef}
          errorAlertRef={errorAlertRef}
          warningAlertRef={warningAlertRef}
          toastMessage={toastMessage}
        />
      </div>
      <style>{css}</style>
    </>
  );
};

export default AccordionStep;
